module.exports = __webpack_public_path__ + "img/accueil-piscine.b969f7c1.jpg";